/* eslint-disable no-undef */
import { UiNextLegacyI18nLoader } from './uinext-i18n';
import { UiNextRegistry } from './uinext-bundles';

export const legacyI18n = new UiNextLegacyI18nLoader({
  registry: new UiNextRegistry(),
});

export function initializeUiNextLegacyI18n() {
  const { serverContext } = window;
  window.globalLegacyI18n = legacyI18n;
  window.globalLegacyI18n.setContext(serverContext);
}
